export default function Knearest_neighbors() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">K-nearest_neighbors</h1>
      <p>Content for K-nearest_neighbors goes here.</p>
    </div>
  );
}
